import React, { useEffect } from "react"

import { graphql } from "gatsby"
import { ArticleVideoFieldsFragment } from "../../../../../../graphql-types"
import * as styles from "./video.module.scss"

import { elementOffset, transformItem } from "../../../functions/functions"

type ArticleVideoProps = {
  data: ArticleVideoFieldsFragment
}

const ArticleVideo: React.FC<ArticleVideoProps> = ({ data: { video } }) => {
  const handleScrollAnimation = () => {
    document.addEventListener("scroll", () => {
      const container = document.getElementsByClassName(styles.container)

      Array.from(container).forEach(artContainer => {
        if (window.scrollY >= elementOffset(artContainer).top - 700) {
          transformItem(artContainer.getElementsByClassName(styles.transformContainer)[0], 400)
        }
      })
    })
  }

  useEffect(() => {
    handleScrollAnimation()
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.transformContainer}>
        <iframe
          src={video}
          title="YouTube Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export const fragment = graphql`
  fragment ArticleVideoFields on DatoCmsArticleVideo {
    __typename
    id
    video
  }
`

export default ArticleVideo
